import { FormControlProps } from "react-bootstrap/FormControl";

import { useWindowDimensions } from "@/hooks/useWindowDimensions";

import { FormattedFormControl } from "@/components/FormControl/FormattedFormControl";
import { SkeletonWrapper } from "@/components/SkeletonWrapper";

type Props = FormControlProps & {
	skeleton?: boolean;
};

export function RespirationFrequency({ skeleton, ...rest }: Props) {
	const { width } = useWindowDimensions();

	return (
		<>
			{skeleton ? (
				<SkeletonWrapper />
			) : (
				<FormattedFormControl
					formattedFormControlClassName="form-control-solid"
					label={`Frequência Respiratória ${(width > 444 && "(RPM)") || ""}`}
					mask="000"
					isMaskedInput
					id={rest.id}
					{...(rest as any)}
				/>
			)}
		</>
	);
}
